import { colors } from '@sodraberget/shared/src/utils/variables';

const pathColor = colors.neutralColor500;
const poiColor = colors.neutralColor500;
const defaultColor = colors.neutralColor500;

const COLORS = {
    PATHS: {
        DEFAULT: pathColor,
        LINE: pathColor,
        CROSS_COUNTRY_SKIING: pathColor,
        SNOWMOBILING: pathColor,
        MOUNTAIN_BIKING: pathColor,
        HIKING: pathColor,
        ENDCAP: pathColor,
        NO_CATEGORY: pathColor,
        RUNNING: pathColor,
        RIDING: pathColor,
        CANOE: pathColor,
        CHAIR_LIFT: pathColor,
        GONDOLA: pathColor,
        SURFACE_LIFT: pathColor,
        BELT_LIFT: pathColor,
        SKI_SLOPE: pathColor,
    },
    POIS: {
        DEFAULT: poiColor,
        NO_CATEGORY: poiColor,
        RESTAURANT: poiColor,
        CAFES: poiColor,
        ATTRACTIONS: poiColor,
        LOOKOUTS: poiColor,
        PARKING: poiColor,
        CABINS: poiColor,
        SKI_BUS: poiColor,
        STORES: poiColor,
        TOILETS: poiColor,
        WARNING: poiColor,
        SHELTER: poiColor,
        ICE_RINK: poiColor,
        SWIMMING_PLACES: poiColor,
        TEMPERATURE: poiColor,
    },
    AOIS: {
        DEFAULT: defaultColor,
        WARNING_AREA: colors.warningAreaColor,
        IMPORTANT_AREA: colors.importantAreaColor,
        INFO_AREA: colors.areaColor
    },
    DIFFICULTY: {
        VERY_EASY: colors.veryEasyColor,
        EASY: colors.easyColor,
        MEDIUM: colors.mediumColor,
        HARD: colors.hardColor,
    },
    
};

export { COLORS };